import { ISelectItem } from '@lla-platform/core/core-ui'

export enum AnalysisEditSource {
  System = 'System',
  User = 'User'
}

export const AnalysisEditSourceToLabel: Record<string, string> = {
  System: 'System',
  User: 'User'
}

export const AnalysisEditSourceItems: ISelectItem[] = Object.values(AnalysisEditSource).map((value) => ({
  label: AnalysisEditSourceToLabel[value],
  value
}))
